export function EmptySpicesState() {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
     
      <p className="text-sm font-medium text-secondary mb-1">No spices added</p>
      <p className="text-xs text-secondary/60 text-center">Add spices from the list to view nutrition facts</p>
    </div>
  );
}
